export default "__VITE_ASSET__BgWjvHig__"